export const recaptchaSiteKey = '6Lez3AUbAAAAAA9NQxf-DQ1W7HLX9kUEk24Wxnyg';
